import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import ms from 'ms';

import { QUERY_KEYS } from 'hb-react/frontoffice/apps/Forum/constants';
import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { getDiscussion } from 'hb-react/frontoffice/apps/Forum/requests';
import { type Discussion } from 'hb-react/frontoffice/apps/Forum/types';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';

export const useGetDiscussion = (discussionId: number) => {
  const { topicId } = useTopicContext();
  const { configUrls } = useForumContext();
  const {
    data: discussion,
    isLoading,
    isError,
  } = useQuery<Discussion, AxiosError>({
    queryKey: [QUERY_KEYS.discussion, discussionId, topicId],
    queryFn: async () => {
      try {
        return await getDiscussion({ discussionId, configUrls });
      } catch (error) {
        if (error?.response?.status === 403) {
          displayXhrError(error);
        }
        throw error;
      }
    },
    staleTime: ms('5m'),
  });

  return { discussion, isLoading, isError };
};
